import { useRef } from "react";
import { motion, useScroll } from "framer-motion";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { PROCESS_STEPS } from "@/data/content";

export const ProcessTimeline = () => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.7", "end 0.75"] });

    return (
        <section id="process" data-testid="process-section" className="blueprint noise relative overflow-hidden py-24 lg:py-36">
            <div className="pointer-events-none absolute -right-40 top-1/3 h-[460px] w-[460px] rounded-full bg-omsivo-blue/30 blur-[140px]" />
            <div className="relative z-10 mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
                <SectionHeading
                    id="process-heading"
                    dark
                    overline="How OMSIVO Works"
                    title={<>Eleven stages. <span className="text-flame">Defined before we begin.</span></>}
                    description="No ambiguity, no surprises. Every OMSIVO project moves through the same transparent eleven-stage process."
                />

                <div ref={ref} className="relative mt-16">
                    <div className="absolute left-[19px] top-0 h-full w-px bg-white/12 sm:left-1/2" />
                    <motion.div className="absolute left-[19px] top-0 h-full w-px origin-top bg-flame sm:left-1/2" style={{ scaleY: scrollYProgress }} />
                    <div className="space-y-8 sm:space-y-0">
                        {PROCESS_STEPS.map((s, i) => (
                            <Reveal key={s.n} delay={0.04} className="sm:grid sm:grid-cols-2 sm:gap-14 sm:py-5">
                                <div className={i % 2 ? "sm:col-start-2" : ""}>
                                    <div className="group relative ml-12 rounded-2xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-sm transition-colors hover:border-flame/50 sm:ml-0"
                                        data-testid={`process-step-${s.n}`}>
                                        <span className={i % 2
                                            ? "absolute -left-[35px] top-7 h-3 w-3 rounded-full border-2 border-flame bg-omsivo-deep transition-colors group-hover:bg-flame sm:-left-[34px]"
                                            : "absolute -left-[35px] top-7 h-3 w-3 rounded-full border-2 border-flame bg-omsivo-deep transition-colors group-hover:bg-flame sm:left-auto sm:-right-[34px]"
                                        } />
                                        <div className="flex items-baseline gap-4">
                                            <span className="font-display text-3xl font-black text-flame">{s.n}</span>
                                            <h3 className="font-display text-lg font-extrabold uppercase tracking-[0.08em] text-white">{s.title}</h3>
                                        </div>
                                        <p className="mt-2 text-sm leading-relaxed text-white/60">{s.text}</p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

